export default {  
    getUserInRoles: (state) => state.userInRoles,
  }